
import React, { useState, useEffect } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/select2.min.css';
import '../../css/style.css';
import '../../css/admin-sidebar.css';
import axios from 'axios';
import AdminSidebar from '../Adminsidebar/AdminSidebar';

const ALLOWED_GALLERY_CATEGORIES = [
    { value: 'Operation Theatre', label: 'Operation Theatre' },
    { value: 'Waiting Area', label: 'Waiting Area' },
    { value: 'Patient Ward', label: 'Patient Ward' },
    { value: 'Laboratory', label: 'Laboratory' },
    { value: 'Pharmacy', label: 'Pharmacy' },
        { value: ' Event & Celebration', label: ' Event & Celebration' },
            { value: 'News', label: 'News' },
];

function AddGallery() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ||  'https://api.hitkarihospital.com:5005';

    const [galleryFile, setGalleryFile] = useState(null);
    const [category, setCategory] = useState(ALLOWED_GALLERY_CATEGORIES[0].value);
    // --- NEW STATE FOR HEADING ---
    const [heading, setHeading] = useState('');
    // -----------------------------
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [uploading, setUploading] = useState(false);

    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [imagesPerPage, setImagesPerPage] = useState(8);
    const [searchTerm, setSearchTerm] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);

    const fetchImages = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/gallery-images`);
            setImages(response.data);
            // setError(''); // Clear fetch error on success if needed
        } catch (fetchError) {
            setError('Error fetching gallery images: ' + (fetchError.response?.data?.message || fetchError.message));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const handleGalleryFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setGalleryFile(e.target.files[0]);
            setMessage('');
            setError('');
        } else {
            setGalleryFile(null);
        }
    };

    const handleCategoryChange = (e) => {
        setCategory(e.target.value);
    };

    // --- NEW HANDLER FOR HEADING ---
    const handleHeadingChange = (e) => {
        setHeading(e.target.value);
    };
    // -------------------------------

    const handleUploadGallery = async () => {
        if (!galleryFile) {
            setMessage('');
            setError('Please select an image to upload.');
            return;
        }
        if (!category) {
            setMessage('');
            setError('Please select a category.');
            return;
        }
        // Optional: Add validation for heading if it becomes mandatory
        // if (!heading.trim()) {
        //     setError('Please enter a heading for the image.');
        //     return;
        // }

        setUploading(true);
        setMessage('Uploading...');
        setError('');

        const formData = new FormData();
        formData.append('category', category);
        // --- APPENDING HEADING TO FORMDATA ---
        formData.append('heading', heading);
        // -------------------------------------
        // formData.append('paragraph', ''); // If you also had a paragraph field

        formData.append('image', galleryFile, galleryFile.name);

        try {
            const response = await axios.post(`${API_BASE_URL}/upload-gallery`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setMessage(response.data.message || 'Image uploaded successfully!');
            setGalleryFile(null);
            setHeading(''); // Clear heading after upload
            fetchImages();
            handleCloseAddModal();
        } catch (uploadError) {
            console.error('Upload error:', uploadError);
            if (uploadError.response) {
                setError(`Upload error: ${uploadError.response.data.message || uploadError.response.statusText}`);
            } else if (uploadError.request) {
                setError('Upload error: No response from server.');
            } else {
                setError(`Upload error: ${uploadError.message}`);
            }
            setMessage('');
        } finally {
            setUploading(false);
        }
    };

    const handleDeleteImage = async (id) => {
        setMessage('Deleting...');
        setError('');
        try {
            const response = await axios.delete(`${API_BASE_URL}/images/${id}`);
            setMessage(response.data.message || 'Image deleted successfully.');
            fetchImages();
        } catch (deleteError) {
            setError('Error deleting image: ' + (deleteError.response?.data?.message || deleteError.message));
            setMessage('');
        }
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    // Updated to search by heading as well, if backend returns it in the image object
    const filteredImages = images.filter(image =>
        (image.path || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (image.originalname || image.filename || '').toLowerCase().includes(searchTerm.toLowerCase()) || // Use originalname or filename
        (image.heading || '').toLowerCase().includes(searchTerm.toLowerCase()) || // Search by heading
        (image.category || '').toLowerCase().includes(searchTerm.toLowerCase()) // Search by category
    );

    const indexOfLastImage = currentPage * imagesPerPage;
    const indexOfFirstImage = indexOfLastImage - imagesPerPage;
    const currentImages = filteredImages.slice(indexOfFirstImage, indexOfLastImage);

    const handleImagesPerPageChange = (e) => {
        setImagesPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };

    const paginate = pageNumber => setCurrentPage(pageNumber);

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredImages.length / imagesPerPage); i++) {
        pageNumbers.push(i);
    }

    const handleShowAddModal = () => {
        setShowAddModal(true);
        setMessage('');
        setError('');
        setGalleryFile(null);
        setCategory(ALLOWED_GALLERY_CATEGORIES[0].value);
        setHeading(''); // Reset heading when modal opens
    };

    const handleCloseAddModal = () => {
        setShowAddModal(false);
        setGalleryFile(null);
        setHeading(''); // Reset heading when modal closes
        setMessage('');
        setError('');
        setUploading(false);
    };

    return (
        <div className="main-wrapper">
            <AdminSidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="row align-items-center mb-3">
                                <div className="col">
                                    <h3 className="page-title">Gallery</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/dash">Dashboard</a></li>
                                        <li className="breadcrumb-item active">Gallery</li>
                                    </ul>
                                </div>
                                <div className="col-auto">
                                    <button type="button" className="btn btn-primary" onClick={handleShowAddModal}>
                                        <i className="fas fa-plus"></i> Add Image
                                    </button>
                                </div>
                            </div>

                            {message && !showAddModal && <div className={`alert ${error ? 'alert-danger' : 'alert-info'} mt-2`}>{message}</div>}
                            {error && !message && !showAddModal && <div className="alert alert-danger mt-2">{error}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by name, category, heading..."
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </div>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <label htmlFor="itemsPerPageSelect" className="mr-2">Items per page:</label>
                                            <select
                                                id="itemsPerPageSelect"
                                                className="form-control form-control-sm d-inline-block"
                                              style={{ width: 'auto',padding: '.25rem 1.5rem'}}
                                                value={imagesPerPage}
                                                onChange={handleImagesPerPageChange}
                                            >
                                                <option value="4">4</option>
                                                <option value="8">8</option>
                                                <option value="12">12</option>
                                                <option value="24">24</option>
                                                <option value="48">48</option>
                                            </select>
                                        </div>
                                        {filteredImages.length > imagesPerPage && (
                                            <nav aria-label="Image pagination">
                                                <ul className="pagination justify-content-center mb-0">
                                                    {currentPage > 1 && (
                                                        <li className="page-item">
                                                            <button onClick={() => paginate(currentPage - 1)} className="page-link">«</button>
                                                        </li>
                                                    )}
                                                    {pageNumbers.map(number => (
                                                        <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                                                            <button onClick={() => paginate(number)} className="page-link">
                                                                {number}
                                                            </button>
                                                        </li>
                                                    ))}
                                                    {currentPage < pageNumbers.length && (
                                                         <li className="page-item">
                                                            <button onClick={() => paginate(currentPage + 1)} className="page-link">»</button>
                                                        </li>
                                                    )}
                                                </ul>
                                            </nav>
                                        )}
                                    </div>
                                    <div className="row custom-gallery-row">
                                        {loading ? (
                                            <div className="col-12 text-center"><p>Loading images...</p></div>
                                        ) : error && images.length === 0 ? (
                                            <div className="col-12 text-center"><p>{error}</p></div>
                                        ) : currentImages.length === 0 && filteredImages.length === 0 && !searchTerm ? (
                                            <div className="col-12 text-center"><p>No images found in the gallery.</p></div>
                                        ) : currentImages.length === 0 && searchTerm ? (
                                            <div className="col-12 text-center"><p>No images match your search criteria.</p></div>
                                        ) : (
                                            currentImages.map((image) => (
                                                <div className="custom-gallery-col col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4" key={image._id}>
                                                    <div className="card h-100">
                                                        <img
                                                            src={`${API_BASE_URL}${image.path}`}
                                                            className="card-img-top"
                                                            alt={image.originalname || image.filename || 'Gallery Image'}
                                                            style={{ height: '200px', objectFit: 'cover' }}
                                                        />
                                                        <div className="card-body d-flex flex-column">
                                                            <h5 className="card-title text-truncate" title={image.heading || image.originalname || image.filename}>
                                                                {image.heading || image.originalname || image.filename}
                                                            </h5>
                                                            <p className="card-text small text-muted">Category: {image.category}</p>
                                                            <button
                                                                className="btn btn-danger btn-sm mt-auto"
                                                                onClick={() => handleDeleteImage(image._id)}
                                                                disabled={message.includes('Deleting...')}
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showAddModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="addModalLabel" aria-modal="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addModalLabel">Upload New Image</h5>
                                <button type="button" className="close" onClick={handleCloseAddModal} aria-label="Close" disabled={uploading}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={(e) => { e.preventDefault(); handleUploadGallery(); }}>
                                    <div className="form-group">
                                        <label htmlFor="categorySelectModal">Category:</label>
                                        <select
                                            id="categorySelectModal"
                                            className="form-control"
                                            value={heading}
                                            onChange={handleHeadingChange}
                                            disabled={uploading}
                                        >
                                            {ALLOWED_GALLERY_CATEGORIES.map(catOpt => (
                                                <option key={catOpt.value} value={catOpt.value}>{catOpt.label}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* ------------------------ */}

                                    <div className="form-group">
                                        <label htmlFor="galleryFileInputModal">Select Image:</label>
                                        <input
                                            type="file"
                                            id="galleryFileInputModal"
                                            className="form-control"
                                            onChange={handleGalleryFileChange}
                                            disabled={uploading}
                                            accept="image/jpeg, image/png, image/gif, image/webp"
                                            onClick={(event) => { event.target.value = null }}
                                        />
                                    </div>

                                    {message && <div className={`alert ${error ? 'alert-warning' : 'alert-info'} mt-2`}>{message}</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}

                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-block"
                                        disabled={uploading || !galleryFile}
                                    >
                                        {uploading ? 'Uploading...' : 'Upload Image'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AddGallery;